import React from "react";
import { Nav } from "../../../../components/ui";

import Notifications from "./Notifications";
import Ticker from "./Ticker";
import UserActions from "./UserActions";

export default () => (
  <Nav navbar className="border-left flex-row">
    {/* {window.screen.width > 767 ? <Ticker /> : ""} */}
    <Notifications />
    <UserActions />
  </Nav>
);
